/**
 * Action types for Trade-In activity
 */
import { Actions as BaseActions } from '@makemydeal/dr-activities-tradein';

export const Actions = {
    ...BaseActions,

    // Generic, host-agnostic signal that the underlying deal changed (e.g. a refresh from the
    // host app). Hosts translate their own deal-update action into this so the trade-in activity
    // can react (such as resetting a stale in-memory route) without knowing the host's action names.
    REFRESH_TRADE_IN: 'REFRESH_TRADE_IN',

    TRADE_IN_LOAN_FLOW_PERSISTED: 'TRADE_IN_LOAN_FLOW_PERSISTED',
    TRADE_IN_STEP_CHANGED: 'TRADE_IN_STEP_CHANGED',
    UPDATE_CURRENT_CUSTOMER: 'UPDATE_CURRENT_CUSTOMER',
    UPDATE_PARTICIPANT_DETAILS: 'UPDATE_PARTICIPANT_DETAILS'
};
